import React from "react";
import cx from "clsx";

import MenuIcon from "@/images/shared/menu-icon.svg";
import CloseIcon from "@/images/shared/close-icon.svg";

import globalStyles from "@/styles/global.module.scss";
import styles from "./navbarButton.module.scss";

const NavbarButton = props => {
  const { isOpen, containerClassName, className, onClick } = props;

  return (
    <div
      className={cx(
        styles.container,
        isOpen && styles.isOpen,
        containerClassName
      )}
    >
      <button
        onClick={onClick}
        className={cx(globalStyles.buttonReset, styles.button)}
      >
        {isOpen ? (
          <CloseIcon
            alt="Close menu"
            width={26}
            height={26}
            className={cx(styles.closeIcon, className)}
          />
        ) : (
          <MenuIcon
            alt="Open menu"
            width={30}
            height={30}
            className={cx(styles.menuIcon, className)}
          />
        )}
      </button>
    </div>
  );
};

export default NavbarButton;
